import React from 'react'
import Navbar from '../components/Navbar'
import { LazyLoadImage } from "react-lazy-load-image-component";

import { Link } from 'react-router-dom'
export default function Home() {
  return (
    <>
      <div className='hero-section'>
        <Navbar />
        <div className='hero-section-content'>
          <div className='hero-section-left'>
            <h1>AMITY INTERNATIONAL MODEL <br></br> <span>UNITED NATIONS CLUB</span></h1>
            <h3>Ascend<span>.</span> Communicate<span>.</span> Settle<span>.</span></h3>
          </div>
          <div className='hero-section-right'>
            
            <LazyLoadImage src={require("../assets/globe.png")} />
          </div>
        </div>
        <marquee scrollamount="5">From debate to dialogue, from words to actions.  Diplomacy is about the interest of the people not the power of the state.</marquee>
      </div>
      <div className='about-us'>
        <h1>About Us</h1>
        <p>The Amity Model United Nations Conference aims to encourage delegates to understand the fundamental working of the United Nations. Delegates will have the opportunity to engage in diplomatic discussion, and broaden their grasp of international relations. AMIMUN shall endeavor to construct a space where delegates will develop a more holistic consciousness of the world and enhance critical thinking, public speaking, and leadership skills. The previous eleven editions of AMIMUN have each set the bar of MUN to such an immersive level due to the experience of the delegates and the guest, we wish to continue the tradition this year.After the success of the past eleven editions, we promise to make this year’s conference bigger and better delivering a meaningful experience through dynamic committees, an array of exceptional speakers, unique engagements, activities, workshops, and training sessions</p>
      </div>
      <div className='container perks'>
        <h1>Club Perks</h1>
      <div className="row text-center ">
        <div className="col text-center">
          <LazyLoadImage className="img img-box mx-auto my-4" src={require("../assets/perk1.png")} alt="" />
        </div>
        <div className="col text-center ">
          <LazyLoadImage className="img img-box mx-auto my-4 " src={require("../assets/perk2.png")} alt="" />
        </div>
        <div className="col text-center ">
          <LazyLoadImage className="img img-box mx-auto my-4" src={require("../assets/perk3.png")} alt="" />
        </div>
      </div>
      </div>
      <div className='pres-message container'>
        <h1>MESSAGE FROM THE PRESIDENT</h1>
        <div className='pres-message-seg'>
          <LazyLoadImage src={require("../assets/president.png")}/>
          <p>We at the Amity University Model United Nations Club, are a set of debaters, who believe that an activity like MUNs, bring about a tangible change, which is shaping our leaders of the future. We believe in the power of student discourse being the solution to the problems which plague us today. I am very proud to be the Member Secretary of one of the largest MUN Clubs in the country, with students of all domains, spending their time working on problems which are necessary to be acted upon.

            AMIMUN Club offers students the chance to hone their public speaking abilities and boost their overall confidence. It teaches students crucial debating techniques that will help them in school and in their career paths. Half the battle is won by being knowledgeable, assured, and credible. Students who learn how to influence others' opinions will have an advantage over their rivals and stand a better chance of developing into effective leaders.

            Rich with experience and led by some of the best in the circuit, we strive to bring out the best in each member of this club and promote the basic values of the United Nations. The talent is present and the future clear. With the support of our mentors, we are unstoppable.

            I personally believe that there is nothing stopping any one of us, from being the next Delegate of India, at the actual United Nations. I have a very simple saying about our club; "The sky's the limit, but that's where the AMIMUN Club begins."<br></br><br></br>Sagar CV<br></br>President</p>
        </div>
      </div>
      <div className='mentorad container'>
        <div class="mentor-box">
          <div class="right">Meet with a Mentor <br />& MUN's Debate Expert</div>
          <Link to="/mentorship"><button>Talk With An Expert</button></Link>
        </div>
      </div>
      <div className='glow-line'></div>
      <div className='custom-footer'>
        AMIMUN &copy; | Amity University
      </div>
    </>
  )
}
